import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Megaphone, X, ArrowRight } from 'lucide-react';
import { NoticeAPI } from '../mock';

export default function NoticeBanner() {
  const [notice, setNotice] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    NoticeAPI.list({ limit: 5 }).then(items => {
      if (!items?.length) return;
      const pinned = items.find(n => n.pinned) || items[0];
      const stored = localStorage.getItem('dismissed_notice');
      if (stored === pinned.id) setDismissed(true);
      setNotice(pinned);
    }).catch(() => {});
  }, []);

  if (!notice || dismissed) return null;

  return (
    <div className="bg-[#e11d2c] text-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-3 flex items-center gap-3">
        <div className="w-7 h-7 grid place-items-center rounded-full bg-black/30 shrink-0"><Megaphone size={13} /></div>
        <div className="flex-1 min-w-0">
          <Link to={`/notices/${notice.id}`} className="block text-[13px] sm:text-[14px] font-semibold truncate hover:underline">
            <span className="opacity-85 uppercase text-[10px] tracking-[0.18em] mr-2">Notice</span>{notice.title}
          </Link>
        </div>
        <Link to={`/notices/${notice.id}`} className="hidden sm:inline-flex items-center gap-1 text-[12px] font-semibold border-b border-white/40 hover:border-white pb-0.5">
          Read <ArrowRight size={13} />
        </Link>
        <button onClick={() => { setDismissed(true); localStorage.setItem('dismissed_notice', notice.id); }} className="w-7 h-7 grid place-items-center rounded-full hover:bg-black/20 shrink-0" aria-label="Dismiss">
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
